(() => {
  const pad = (value) => String(value).padStart(2, '0');

  const remainingUntilLocalMidnight = () => {
    const now = new Date();
    const midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0);
    const totalSeconds = Math.max(0, Math.floor((midnight.getTime() - now.getTime()) / 1000));
    return {
      hours: Math.floor(totalSeconds / 3600),
      minutes: Math.floor((totalSeconds % 3600) / 60),
      seconds: totalSeconds % 60
    };
  };

  const updateCountdowns = () => {
    const remaining = remainingUntilLocalMidnight();
    const accessible = `${remaining.hours} hours, ${remaining.minutes} minutes and ${remaining.seconds} seconds until midnight`;

    document.querySelectorAll('[data-fft-midnight-countdown]').forEach((timer) => {
      const hours = timer.querySelector('[data-fft-hours]');
      const minutes = timer.querySelector('[data-fft-minutes]');
      const seconds = timer.querySelector('[data-fft-seconds]');
      if (hours) hours.textContent = pad(remaining.hours);
      if (minutes) minutes.textContent = pad(remaining.minutes);
      if (seconds) seconds.textContent = pad(remaining.seconds);
      timer.setAttribute('aria-label', accessible);
    });

    document.querySelectorAll('[data-fft-midnight-compact]').forEach((timer) => {
      timer.textContent = `${pad(remaining.hours)}:${pad(remaining.minutes)}:${pad(remaining.seconds)}`;
      timer.setAttribute('aria-label', accessible);
    });
  };

  const start = () => {
    updateCountdowns();
    if (!window.__fresh4TwoMidnightInterval) {
      window.__fresh4TwoMidnightInterval = window.setInterval(updateCountdowns, 1000);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', updateCountdowns);
})();
